export enum BeamLineType {
  PRIMARY_BEAM_LINE = 'LONGITBEAMLINE',
  SECONDARY_BEAM_LINE = 'TRANSVBEAMLINE',
  HELP_PRIMARY_BEAM_LINE = 'HELPLONGITBEAMLINE',
  PRIMARY_BEAM_LINE_FOR_TABLE = 'TABLEFORMCLOSUREBEAMLINE',
  UNKNOWN = '',
}
